// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Modules
import { MixedCheckbox } from '@reach/checkbox';
import VisuallyHidden from '@reach/visually-hidden';
// Utils
import { getGender } from '@utmb/utils/gender';
// Interface
import { IconsEnum } from '@utmb/types/icons';
import { SexEnum } from '@utmb/types/enum/SexEnum';
// Design System
import { DropDown, DropDownItem } from '@utmb/design-system/dropdown/Dropdown';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Separator } from '@utmb/design-system/separator/Separator';
import { GenderFilterProps } from '@utmb/types/start-list-table';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './filters.module.scss';

const GenderFilter = (props: GenderFilterProps): ReactElement => {
    const { currentGender, setCurrentGender } = props;

    const genders = [SexEnum.MEN, SexEnum.WOMEN];

    const { t } = useTranslation();

    const handleInputGenderChange = (gender: string): void => {
        if (currentGender === gender) {
            setCurrentGender('');
        } else {
            setCurrentGender(gender);
        }
    };

    return (
        <div className={styles.toolbar}>
            <DropDown
                className={styles.drop}
                button={({ isExpanded }) => (
                    <>
                        <Font.OxaniumMedium mobile="14" desktop="14" className={styles.filter_label}>
                            {currentGender ? t(getGender(currentGender)) : t('common.gender.label')}
                            {/**t('common.gender.label')*/}
                        </Font.OxaniumMedium>
                        <Icon color={'var(--utmb-color-ws-primary)'} variant={IconsEnum[isExpanded ? 'CHEVRON_UP' : 'CHEVRON_DOWN']} />
                    </>
                )}
            >
                {genders.map((gender: string, index: number) => {
                    const checked = gender === currentGender;

                    const hasSeparator = index < genders.length - 1;

                    return (
                        <div key={index} className={styles.item_wrapper}>
                            <DropDownItem onSelect={() => handleInputGenderChange(gender)} className={styles.item}>
                                <Font.OxaniumMedium mobile="12" desktop="14" as="span">
                                    {t(getGender(gender))}
                                </Font.OxaniumMedium>
                                <label>
                                    <MixedCheckbox value={gender} checked={true} />
                                    {checked && <Icon variant={IconsEnum.CHECKBOX} color="rgba(65, 80, 92,.8)" />}
                                    <VisuallyHidden> {gender}</VisuallyHidden>
                                </label>
                            </DropDownItem>
                            {hasSeparator && <Separator color="rgba(65, 80, 92,.2)" spacing="0 auto" depth={`calc(100% - ${rem('15px')})`} />}
                        </div>
                    );
                })}
            </DropDown>
        </div>
    );
};

export default GenderFilter;
